<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header py-4">
          <div class="row align-items-center">
            <div class="col-9 font-size-16">Criar uma nova Squad</div>
            <div class="col-3">
              <button
                type="button"
                class="btn btn-sm btn-info float-end"
                @click="$emit('handle2')"
              >Voltar</button>
            </div>
          </div>
        </div>
        <div class="card-body">
          <form @submit.prevent="onSubmit">
            <div class="row align-items-center">
              <div class="col-4">
                <app-input-text v-model="squad.name" label="*Nome" c_css @input="checkFormFilled" />
              </div>
              <div class="col-4">
                <app-input-text
                  v-model="squad.description"
                  label="*Sharepoint"
                  c_css
                  @input="checkFormFilled"
                />
              </div>
              <div class="col-4">
                <app-input-search :items="users" label="Pessoas" @handle="addUser" />
              </div>
            </div>
            <div class="row align-items-center">
              <div class="col-12">
                <label class="form-check-label mb-2">({{squad.users.length}}) Pessoa(s)</label>
                <div class="table-responsive">
                  <table class="table table-striped mb-0 table-bordered">
                    <thead>
                      <tr>
                        <th width="60">-</th>
                        <th width="50%">Nome</th>
                        <th>Administrador do grupo?</th>
                        <th width="40">-</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(user, index2) in squad.users" v-bind:key="index2">
                        <td>
                          <div class="avatar-xs m-1" :title="user.name">
                            <span
                              class="avatar-title rounded-circle"
                              v-bind:class="['named-', user.name[0]]"
                            >{{ user.name | initials }}</span>
                          </div>
                        </td>
                        <td>
                          {{user.name}}
                          <br />
                          {{user.email}}
                        </td>
                        <td>
                          <app-button-true-or-false
                            :disabled="Boolean(parseInt(user.pivot.is_admin))"
                            @handle="squad.users[index2].pivot.is_admin = (squad.users[index2].pivot.is_admin == 1 ? 0 : 1); message = true;"
                          />
                        </td>
                        <td>
                          <app-button-delete-confirm
                            @handle="removeUser(squad.users[index2].pivot.user_id);"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-6 mt-3">
                <button
                  type="submit"
                  class="btn btn-primary waves-effect waves-light"
                  :disabled="!isFormFilled"
                >Salvar</button>
                <span class="badge rounded-pill bg-danger m-1" v-if="message">*alterações não salvas</span>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AppInputText from "@/components/AppInputText/AppInputText.vue";
import AppInputSearch from "@/components/AppInputSearch/AppInputSearch.vue";
import AppButtonDeleteConfirm from "@/components/AppButtonDeleteConfirm/AppButtonDeleteConfirm.vue";
import AppButtonTrueOrFalse from "@/components/AppButtonTrueOrFalse/AppButtonTrueOrFalse.vue";
import { mapActions } from "vuex";
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    users: {
      type: Array,
      default: () => []
    }
  },
  components: {
    AppInputText,
    AppInputSearch,
    AppButtonDeleteConfirm,
    AppButtonTrueOrFalse
  },
  data() {
    return {
      isFormFilled: false,
      squad: {
        name: null,
        description: null,
        users: []
      },
      temp: null,
      message: false,
      selected: {}
    };
  },
  computed: {
    alertMessage() {
      return "";
    },
    toggleActive() {
      return {
        active: this.isActive,
        "toggle-on": this.isActive,
        "toggle-off": !this.isActive
      };
    }
  },
  mounted() {
    if (this.item) {
      this.getSquad();
      this.checkFormFilled();
    }
  },
  methods: {
    ...mapActions([
      "showMessage",
      "showLoader",
      "setLoaderTitle",
      "showBlockScreen"
    ]),
    getSquad() {
      let original = JSON.parse(JSON.stringify(this.item));
      this.squad.name = original.name;
      this.squad.description = original.description;
      this.squad.users = (original.users && Object.keys(original.users).length > 0) ? original.users : [];
    },
    onSubmit() {
      
      let _this = this;
      _this.showLoader(true);
      let temp = _this.createArrayPost(_this.squad.users);
      const data = {
        name: _this.squad.name,
        description: _this.squad.description,
        users: temp
      };
      
      let headers = {};
      if (_this.item && Object.keys(_this.item).length > 0) {
        
        headers = _this.$getAPIHeaders("PATCH", `team/${_this.item.id}`, data);
      } else {
        
        headers = _this.$getAPIHeaders("POST", `team`, data);
      }
      
      this.axios(headers)
        .then(function(response) {
          _this.showLoader(false);
          _this.showMessage({
            title: response.data.message,
            css: "bg-success"
          });
          
          _this.onAction(response.data.data);
        })
        .catch(function(error) {
          _this.showLoader(false);
          _this.showMessage({
            title: error.response.data.message,
            text: _this.$root.$options.filters.objectError(
              error.response.data.errors
            ),
            css: "bg-danger"
          });
        });
    },
    onAction(data) {
      this.$emit("handle", data);
    },
    checkFormFilled() {
      this.isFormFilled =
        this.squad.name !== null && this.squad.description !== null;
    },
    addUser(id) {
      if (this.squad.users.some(user => user.id === id)) return;
      const temp = this.users.find(user => user.id === id);
      if (!temp) return;
      const user = {
        id: temp.id,
        name: temp.name,
        email: temp.email,
        pivot: {
          user_id: temp.id,
          is_admin: 0
        }
      };
      this.squad.users.push(user);
      this.message = true;
    },
    removeUser(id) {
      this.squad.users = this.squad.users.filter(u => u.id !== id);
      this.message = true;
    },
    createArrayPost(arr) {
      
      let ret = [];
      if (arr.length > 0) {
        for (const el of arr) {
          let temp = {};
          temp.user_id = el.id;
          temp.is_admin = el.pivot.is_admin;
          ret.push(temp);
        }
      }
      
      return ret;
    }
  }
};
</script>
<style scoped>
.avatar-xs {
  display: inline-block;
}
</style>